// Presentation carries no authority. Machine codes stay finite strings; raw
// exception messages, arbitrary objects and provider bodies never become copy.
export function sdkErrorCode(value, fallback = 'UNAVAILABLE') {
  let code = value;
  if (typeof value !== 'string') {
    try {
      code = Object.getOwnPropertyDescriptor(value ?? {}, 'code')?.value;
    } catch {
      return fallback;
    }
  }
  return typeof code === 'string' && /^[A-Za-z][A-Za-z0-9_]{0,63}$/.test(code) ? code : fallback;
}

export function sdkErrorMessage(value) {
  return typeof value === 'string' && value.trim() && value.length <= 512 ? value : null;
}
